import React from "react";
import { Reveal, MaskLine, Wordmark } from "../components/Motion";

const CHAPTERS = [
  { n: "01", t: "Sun-faded surf culture", b: "It starts at the coast — washed-out blacks, salt-worn cotton, the ease of something you've worn all summer. We chase that faded, been-there feeling in every fabric." },
  { n: "02", t: "Vintage thrift finds", b: "We dig through the racks so the silhouette feels found, not manufactured. Layered tees, baggy denim, and the raised multicolor stitchwork nodding to early-internet marketplace lettering." },
  { n: "03", t: "Washed & distressed by hand", b: "Every piece is garment-washed and lightly distressed so it lands already lived in. No stiff, brand-new stiffness — just the good kind of worn." },
  { n: "04", t: "Modern streetwear, made timeless", b: "We take all of it and rebuild it clean: boxy cuts, honest fabrics, nothing loud except the stitch. Pieces meant to outlast the drop they came from." },
];

export default function OurStory() {
  return (
    <div data-testid="our-story-page">
      <div className="relative h-[60vh] min-h-[420px] overflow-hidden">
        <img src="/brand/stairwell.png" alt="Our story" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-bg via-bg/40 to-transparent" />
        <div className="absolute bottom-10 left-0 w-full">
          <div className="max-w-[1500px] mx-auto px-4 sm:px-8">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-cs-yellow mb-4">Our Story</p>
            <h1 className="font-display font-extrabold text-6xl sm:text-8xl uppercase leading-[0.82]">
              <MaskLine>Already</MaskLine>
              <MaskLine delay={0.1}>Yours</MaskLine>
            </h1>
          </div>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-20 sm:py-28 text-center">
        <Reveal>
          <Wordmark className="text-3xl" />
          <p className="font-editorial text-2xl sm:text-3xl leading-[1.4] mt-8">
            Covertswag blends sun-faded surf culture, vintage thrift finds, washed fabrics, and modern streetwear into timeless pieces that feel already lived in.
          </p>
        </Reveal>
      </div>

      <div className="max-w-[1100px] mx-auto px-4 sm:px-8 pb-24 sm:pb-32">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={0.05} className="grid sm:grid-cols-[140px_1fr] gap-4 sm:gap-10 py-10 border-t border-line">
            <span className="font-editorial text-6xl sm:text-7xl text-graytx leading-none">{c.n}</span>
            <div>
              <h3 className="font-display font-extrabold text-2xl sm:text-3xl uppercase">{c.t}</h3>
              <p className="text-graytx mt-3 leading-relaxed">{c.b}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
